import React, { useState } from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  const navigate = useNavigate();

  const location = useLocation();

  const {
    restaurantId,
    tableId,
  } = useParams();


  const {
    cartCount,
  } = useCart();


  const [menuOpen, setMenuOpen] =
    useState(false);


  // =====================================================
  // HOME PATH
  // =====================================================

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  // =====================================================
  // CLOSE MOBILE MENU
  // =====================================================

  const closeMobileMenu = () => {

    setMenuOpen(false);

  };


  // =====================================================
  // GO TO HOME
  // =====================================================

  const handleHome = () => {

    closeMobileMenu();


    if (
      location.pathname === homePath
    ) {

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;

    }


    navigate(homePath);

  };


  // =====================================================
  // GO TO SECTION
  // =====================================================

  const goToSection = (
    sectionId
  ) => {

    closeMobileMenu();


    if (
      location.pathname === homePath
    ) {

      const element =
        document.getElementById(
          sectionId
        );


      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;

    }


    navigate(homePath);


    setTimeout(() => {

      const element =
        document.getElementById(
          sectionId
        );


      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

    }, 500);

  };


  // =====================================================
  // ABOUT
  // =====================================================

  const handleAbout = () => {

    goToSection(
      "t7-why"
    );

  };


  // =====================================================
  // CONTACT
  // =====================================================

  const handleContact = () => {

    goToSection(
      "t7-footer-contact"
    );

  };


  // =====================================================
  // BLENDS
  // =====================================================

  const handleBlends = () => {

    goToSection(
      "t7-menu"
    );

  };


  // =====================================================
  // CART
  // =====================================================

  const handleCart = () => {

    closeMobileMenu();


    navigate(
      `${homePath}/cart`
    );

  };


  // =====================================================
  // MOBILE MENU
  // =====================================================

  const toggleMobileMenu = () => {

    setMenuOpen(
      (previous) =>
        !previous
    );

  };


  return (

    <header className="t7-header">


      <div className="t7-header-inner">


        {/* =================================================
            MOBILE HAMBURGER
        ================================================= */}

        <button
          type="button"
          className={
            `t7-hamburger ${
              menuOpen
                ? "active"
                : ""
            }`
          }
          onClick={
            toggleMobileMenu
          }
          aria-label="Open menu"
          aria-expanded={
            menuOpen
          }
        >

          <span></span>
          <span></span>
          <span></span>

        </button>



        {/* =================================================
            LEFT NAVIGATION
        ================================================= */}

        <nav className="t7-header-navigation">


          <button
            type="button"
            className={
              location.pathname ===
              homePath
                ? "active"
                : ""
            }
            onClick={
              handleHome
            }
          >
            Home
          </button>


          <button
            type="button"
            onClick={
              handleAbout
            }
          >
            About
          </button>


          <button
            type="button"
            onClick={
              handleContact
            }
          >
            Contact
          </button>


          <button
            type="button"
            onClick={
              handleBlends
            }
          >
            Blends
          </button>


        </nav>



        {/* =================================================
            CENTER LOGO
        ================================================= */}

        <button
          type="button"
          className="t7-header-logo"
          onClick={
            handleHome
          }
        >

          <span className="t7-logo-main">
            Spice<span>&amp;</span>Saffron
          </span>


          <span className="t7-logo-sub">
            INDIAN CUISINE
          </span>

        </button>



        {/* =================================================
            RIGHT ACTIONS
        ================================================= */}

        <div className="t7-header-actions">


          {/* TABLE */}

          <div className="t7-header-table">

            <span>
              TABLE
            </span>

            <strong>
              {tableId}
            </strong>

          </div>



          {/* CART */}

          <button
            type="button"
            className="t7-header-cart"
            onClick={
              handleCart
            }
            aria-label="Open cart"
          >

            <span className="t7-cart-icon">
              🛒
            </span>


            <span className="t7-cart-label">
              CART
            </span>


            {cartCount > 0 && (

              <span className="t7-cart-count">
                {cartCount}
              </span>

            )}

          </button>


        </div>


      </div>



      {/* =================================================
          MOBILE MENU
      ================================================= */}

      <div
        className={
          `t7-mobile-menu ${
            menuOpen
              ? "open"
              : ""
          }`
        }
      >

        <button
          type="button"
          onClick={
            handleHome
          }
        >
          Home
        </button>


        <button
          type="button"
          onClick={
            handleAbout
          }
        >
          About
        </button>


        <button
          type="button"
          onClick={
            handleContact
          }
        >
          Contact
        </button>


        <button
          type="button"
          onClick={
            handleBlends
          }
        >
          Blends
        </button>


        <button
          type="button"
          className="t7-mobile-cart"
          onClick={
            handleCart
          }
        >
          Cart
          {cartCount > 0 && (
            <span>
              {cartCount}
            </span>
          )}
        </button>

      </div>

    </header>

  );

}


export default Header;